import { Card, Typography, Box } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
export default function SuccessScreen() {

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f9fafb",
            }}
        >
            <Card
                variant="outlined"
                sx={{
                    padding: 4,
                    maxWidth: 420,
                    textAlign: "center",
                    borderRadius: 3,
                }}
            >
                <CheckCircleRoundedIcon
                    sx={{ fontSize: 80, color: "success.main", mb: 2 }}
                />

                <Typography variant="h5" fontWeight={600} gutterBottom>
                    Stripe Account Connected Successfully
                </Typography>

                <Typography color="success">
                    Your Stripe account has been connected and is ready to receive payments.
                </Typography>

            </Card>
        </Box>
    );
}
